module.exports = __webpack_public_path__ + "static/media/bye3.05c9b2bd.gif";